export default "__VITE_ASSET__750EhV0E__"